import React from 'react';
import './ProcessingStep.scss';
import moment from 'moment';
import { convertTimeStamp } from 'utils/utils';
import { Block } from 'components/Block';

const STYLE_TYPE_ACTIVE = [2, 3];

export const ProcessingStep = (props) => {
  const { data } = props;
  const { data_by_status: dataByStatus } = data;
  const {
    expected_times: expectedTimes = [],
    heading_status: headingStatus,
    display_statuses: displayStatuses = [],
  } = dataByStatus;
  let currentActive = 0;
  displayStatuses.forEach((item, index) => {
    if (STYLE_TYPE_ACTIVE.includes(item.style_type) && index >= currentActive) {
      currentActive = index;
    }
  });

  return (
    <Block
      title={headingStatus}
      desc={expectedTimes.map((item) => (
        [item.name, moment.unix(item.time).isSame(moment(), 'day')
          ? convertTimeStamp(item.time, 'HH:mm')
          : convertTimeStamp(item.time, 'HH:mm DD/MM')]
      ))}
      line
    >
      <div className='processing-status'>
        {displayStatuses.map((item, index) => {
          const { status_name: statusName, update_time: updateTime } = item;
          return (
            <div
              key={index}
              className={`processing-status__step ${
                currentActive >= index ? 'active' : ''
              }`}
            >
              {/* {currentActive === index && (
                <div className="processing-current-status-bg" />
              )} */}
              <div className='processing-status__step-name'>{statusName}</div>
              {updateTime && (
                <div className='processing-status__step-time'>
                  {convertTimeStamp(updateTime)}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </Block>
  );
};
